import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ErrorPageComponent} from './error-page.component';
import {MatCardModule} from '@angular/material';

@NgModule
({
  declarations:
  [
    ErrorPageComponent
  ],
  exports:
  [
    ErrorPageComponent
  ],
  imports:
    [
      CommonModule,
      MatCardModule
    ]
})
export class ErrorPageModule
{

}
